const fi = {
    common: {
        addNew: "Lisää uusi",
        create: "Luo",
        close: "Sulje",
        clear: "Tyhjennä",
        reset: "Nollaa",
        search: "Etsi",
        update: "Päivitä",
        edit: "Muokkaa",
        cancel: "Peruuta",
        delete: "Poista",
        filter: "Suodata",
        save: "Tallenna",
        saveChanges: "Tallenna muutokset",
        tba: "Ominaisuus tulossa",
        reason: "Syy: {reason}",
        error: "Virhe",
        next: "Seuraava"
    },
    login: {
        loginButton: "Kirjaudu sisään",
        logOut: "Kirjaudu ulos",
        enablePopUps: "Salli pop-up-ikkunoiden näyttö selaimen niin pyytäessä. Pop-up ikkunaa tarvitaan sisäänkirjautumiseen.",
        redirectInfo: "Sinut ohjataan Azure AD:hen turvallista kirjautumista varten.",
        redirectingMessage: "Ohjataan kirjautumiseen..."
    },
    auth: {
        initializing: "Alustetaan...",
        initializingMessage: "Määritetään istuntoa, odota hetki",
        processing: "Käsitellään kirjautumista",
        processingMessage: "Odota kun viimeisttelemme sisäänkirjautumista",
        timeoutError: "Kirjautuminen kestää odotettua pidempään. Yritä uudelleen.",
        callbackError: "Kirjautumisen käsittelyssä tapahtui virhe. Yritä uudelleen.",
        retryError: "Kirjautumisen uudelleenyritys epäonnistui. Päivitä sivu.",
        retry: "Yritä uudelleen",
        unauthorized: {
            title: "Pääsy evätty",
            message: "Sinulla ei ole oikeutta käyttää tätä sivua",
            description: "Tilillasi ei ole tarvittavia käyttöoikeuksia tämän sisällön katseluun. Ota yhteyttä järjestelmänvalvojaan, jos uskot tämän olevan virhe.",
            goHome: "Siirry etusivulle",
            signOut: "Kirjaudu ulos",
            contactAdmin: "Jos tarvitset käyttöoikeuksia, ota yhteyttä järjestelmänvalvojaan"
        }
    },
    home: {
        title: "Etusivu",
        noPermission: "Sinulla ei ole oikeutta katsella graafeja. Ota yhteyttä tuki@taksikuutio.fi",
        noOfTrips: "Matkojen määrä",
        startDate: "Alkupäivä",
        endDate: "Loppupäivä",
        statusesOfLastXDays: "Viimeisten {days} päivän aikana ajettujen matkojen tila",
        transportEventErrors: "Tarkistettavia matkoja",
        errorType: "Poikkeama tyyppi",
        errorCount: "Määrä",
        latestSalesInvoices: "Viimeisimmät laskut",
        latestPurchaseInvoices: "Viimeisimmät tilitykset",
        invoiceNumber: "Laskunumero",
        events: "Tapahtumia"
    },
    validations: {
        title: "Validaatiot"
    },
    pricing: {
        title: "Hinnoittelu"
    },
    customers: {
        title: "Asiakkaat"
    },
    userManagement: {
        title: "Käyttäjähallinta",
        operator: "Operaattori",
        addCustomer: "Lisää yritys",
        headers: {
            name: "Nimi",
            description: "Kuvaus",
            externalId: "Tunniste",
            businessId: "Y-tunnus"
        },
        dialog: {
            createCustomer: "Luo yritys",
            updateCustomer: "Muokkaa yrityksen tietoja",
            attributeSelectLabel: "Oletus Autotyypit",
            name: "Nimi",
            contact: "Yhteyshenkilö",
            description: "Kuvaus",
            billingInfo: "Laskutustiedot",
            address: "Osoite",
            phone: "Puhelinnumero",
            email: "Sähköposti",
            businessId: "Y-tunnus",
            operator: "Operaattori",
            identifier: "Tunniste",
            validate: "Vahvista",
            staticAddresses: "Kiinteät osoitteet"
        },
        noOperatorsError: "Sinulla ei ole oikeuksia yhteenkään operaattoriin. Ota yhteyttä tuki@taksikuutio.fi"
    },
    customerDetails: {
        operator: "Operaattori",
        externalId: "Tunniste",
        businessId: "Y-tunnus",
        contact: "Yhteyshenkilö",
        billingInfo: "Laskutustiedot",
        modifyCustomer: "Muokkaa yritystä",
        createRegistrationCode: "Luo rekisteröintikoodi",
        createDiscountCode: "Luo alennuskoodi",
        addUser: "Lisää käyttäjä",
        userDeleteConfirm: "Haluatko varmasti poistaa tämän käyttäjän?",
        usersTitle: "Käyttäjät",
        favoriteAddressesTitle: "Suosikkiosoitteet",
        headers: {
            name: "Nimi",
            email: "Sähköposti",
            phone: "Puhelinnumero",
            billing: "Laskutus",
            taksini: "Taksini-käyttäjä",
            card: "Kortti"
        },
        userDialog: {
            createUser: "Luo käyttäjä",
            editUser: "Muokkaa käyttäjää",
            userId: "Tunniste",
            firstName: "Etunimi",
            middleName: "Toinen nimi",
            lastName: "Sukunimi",
            costCenter: "Kustannuspaikka",
            beneficiaryId: "Sisäinen tunniste",
            email: "Sähköposti",
            phone: "Puhelinnumero",
            allowBilling: "Salli laskutus (vain yritys)",
            allowTaksini: "Taksini-käyttäjä",
            allowTaksiniHint: "Taksini-käyttäjää ei pysty muokkaamaan luomisen jälkeen",
            allowCard: "Salli kortti",
            validate: "Vahvista",
            taksiniUserEditing: "Käyttäjä on Taksini-käyttäjä, osaa arvoista ei voi muokata."
        },
        codeDialog: {
            createNewRegistrationCode: "Luo rekisteröintikoodi",
            createNewDiscountCode: "Luo alennuskoodi",
            code: "Koodi",
            generateCode: "Generoi koodi",
            machineGenerateCode: "Järjestelmä generoi koodit",
            userGenerateCode: "Käyttäjä antaa koodin",
            multipleUse: "Monikäyttöinen",
            singleUse: "Kertakäyttöinen",
            pleaseCopy: "Koodia ei näytetä tämän dialogin sulkemisen jälkeen. Kopioi se talteen.",
            codesAmount: "Koodien määrä",
            infiniteUse: "Rajaton käyttö",
            userMaxUseCount: "Käyttäjän käyttömäärä",
            codeMaxUseCount: "Koodin käyttömäärä",
            discountValue: "Määrä",
            codeTypePercentage: "Prosentti",
            codeTypeFixed: "Kiinteä summa",
            userProvidedCodesLabel: "Käyttäjän antamat koodit (valinnainen)",
            codeGenerationHint: "Kuinka monta koodia luodaan?",
            userMaxUseCountHint: "Kuinka monta kertaa käyttäjä voi käyttää koodia?",
            codeMaxUseCountHint: "Kuinka monta kertaa tätä koodia voidaan käyttää?",
            userProvidedCodesHint: "Syötä koodit jotka haluat että luodaan"
        },
        favoriteAddressHeaders: {
            addressType: "Tyyppi",
            street: "Katuosoite",
            streetNumber: "Katunumero",
            city: "Kaupunki",
            zipcode: "Postinumero",
            country: "Maa",
            alias: "Alias",
            driverNotes: "Viesti kuljettajalle",
            door: "Ovi"
        }
    },
    scheduler: {
        title: "Ajastus",
        openDialog: "Luo ajastus",
        creationgTitle: "Ajastus",
        newCron: "Uusi ajastus",
        oldCron: "Vanha ajastus",
        schedules: "Ajastukset",
        utcNote: "HUOM: Ajastukset suoritetaan UTC-aikavyöhykkeellä, paikallinen aikasi on UTC {0}"
    },
    kelaBatch: {
        title: "Kela-erät",
        search: "Hae Kela-eriä",
        refresh: "Päivitä",
        region: "Alue",
        year: "Vuosi",
        tilitysNro: "Tilitys nro",
        siirtotunnus: "Siirtotunnus",
        sentAt: "Lähetetty kelalle",
        transportEventCount: "Tapahtumat",
        totalCost: "Kustannus",
        totalReimbursement: "Korvaus",
        feedbackStatus: "PAL-Sanoma",
        settlementStatus: "TIL-Sanoma",
        containsCombinedTrips: "Yhdistelymatkat",
        feedbackPending: "Odottaa",
        fileName: "Tiedostonimi",
        basicInfo: "Perustiedot",
        summary: "Yhteenveto",
        feedback: "PAL-Sanoma",
        settlement: "TIL-Sanoma",
        feedbackReceived: "Vastaanotettu",
        feedbackFile: "Palautetiedosto",
        settlementReceived: "Vastaanotettu",
        settlementFile: "Tilitystiedosto",
        settlementFiles: "Tilitystiedostot",
        containsCombinedYes: "Kyllä",
        containsCombinedNo: "Ei",
        eventIds: "Tapahtuma-IDt",
        showEvents: "Näytä tapahtumat",
        copyToClipboard: "Kopioi leikepöydälle",
        copiedToClipboard: "Kopioitu leikepöydälle",
        waitingCount: "Odottaa",
        processedCount: "Käsitelty",
        otherCount: "Muut",
        allTrips: "Kaikki",
        combinedTrips: "Sisältää yhdistettyjä",
        singleTrips: "Vain yksittäisiä",
        sentFrom: "Lähetetty alkaen",
        sentTo: "Lähetetty päättyen",
        clearFilter: "Tyhjennä",
        closeDialog: "Sulje",
        summaryPending: "Odottaa Kelan päätöstä",
        summaryProcessed: "Käsitelty (OK)",
        summaryError: "Virhe (VIRHE)",
        monthlyChart: "Korvaus per kuukausi",
        batches: "erää",
        events: "tapahtumaa"
    },
    provisionBatch: {
        title: "Provisio-erät",
        details: {
            title: "Erän tiedot",
            batchInformation: "Erän tiedot",
            tenant: "Yritys",
            started: "Aloitettu",
            completed: "Valmistunut",
            inProgress: "Kesken",
            duration: "Kesto",
            status: "Tila",
            totalEvents: "Tapahtumia yhteensä",
            purchaseInvoices: "Ostolaskuja",
            salesInvoices: "Myyntilaskuja",
            statusHistory: "Tilahistoria",
            count: "Määrä",
            areaSummary: "Alueiden yhteenveto",
            area: "Alue",
            events: "Tapahtumat",
            acceptedCostGross: "Hyväksytty hinta (brutto)",
            reimbursementNet: "Korvaus (netto)",
            baseProvision: "Perusprovisio",
            transactionProvision: "Transaktioprovisio",
            sourceProvision: "Lähdeprovisio",
            purchaseInvTotal: "Ostolaskun summa",
            salesInvTotal: "Myyntilaskun summa",
            netToCompany: "Netto taksiyritykselle",
            purchaseInvoiceNumber: "Ostolaskun nro",
            salesInvoiceNumber: "Myyntilaskun nro",
            total: "YHTEENSÄ",
            downloadReports: "Lataa raportit",
            jsonSummary: "JSON-yhteenveto",
            eventIds: "Tapahtumatunnukset",
            detailedJson: "Yksityiskohtainen JSON",
            monthlyBreakdown: "Kuukausittainen jakauma (Trip.Started)",
            month: "Kuukausi",
            amount: "Määrä",
            provisionConfiguration: "Provisioasetukset",
            calculationBase: "Laskentaperuste",
            noDataAvailable: "Ei lisätietoja saatavilla. Tämä erä on saatettu luoda ennen näiden tietojen keräämistä.",
            reportDialog: {
                title: "Luo provisiotilitys",
                selectAreas: "Valitse mukaan otettavat alueet",
                selectAll: "Valitse kaikki",
                reportReference: "Lisätieto / viite (valinnainen)",
                generate: "Luo raportti",
                cancel: "Peruuta",
                noAreasSelected: "Valitse vähintään yksi alue",
                generateReport: "Luo raportti"
            }
        }
    },
    invoicing: {
        title: "Maksuhallinta",
        invoicingOptions: "Laskutusasetukset",
        transportEvents: "Matkatapahtumat",
        transportEventFilters: "Matkatapahtumien suodattimet",
        invoiceoptionsRequired: "Laskutusasetukset tulee olla valittuna",
        eventsFilterRequired: "Matkatapahtumien suodatin tulee olla valittuna",
        options: {
            updated: "Laskutusasetukset päivitetty",
            created: "Laskutusasetukset luotu",
            deleted: "Laskutusasetukset poistettu",
            newOption: "Uusi laskutusasetus",
            optionName: "Asetuksen nimi",
            erpSystem: "ERP-järjestelmä",
            editOptions: "Muokkaa laskutusasetuksia",
            confirmDelete: "Haluatko varmasti poistaa tämän laskutusasetuksen?",
            minimumOptionNameLength: "Asetuksen nimen tulee olla vähintään 3 merkkiä pitkä",
            erpSystemRequired: "ERP-järjestelmä on pakollinen",
            tabs: {
                generic: "Yleiset",
                sales: "Myyntilasku",
                purchase: "Ostolasku"
            },
            groups: {
                salesGeneral: "Yleiset myyntilaskuasetukset",
                invoiceDetails: "Laskun tiedot",
                transportEventRow: "Matkatapahtuma-rivi",
                deliveryParty: "Toimitusosoite",
                vatRow: "ALV-rivi",
                deductibleRow: "Vähennyskelpoinen rivi",
                bcSales: "BC Myynti",
                purchaseGeneral: "Yleiset ostolaskuasetukset",
                generalSettings: "Yleiset asetukset",
                tripsRow: "Matkat-rivi",
                tripsVatRow: "Matkat ALV-rivi",
                transactionRow: "Transaktio-rivi",
                transactionVatRow: "Transaktio ALV-rivi",
                externalProvisionRow: "Ulkoinen provisio -rivi",
                externalProvisionVatRow: "Ulkoinen provisio ALV-rivi",
                settlementRow: "Tilitys-rivi",
                installments: "Erät",
                vendorProvision: "Toimittajan provisio",
                vendorProvisionVatRow: "Toimittajan provisio ALV-rivi",
                invoiceDates: "Laskun päivämäärät",
                bcPurchase: "BC Osto"
            }
        },
        transportEventTypes: {
            title: "Matkatapahtumatyypit",
            unknown: "Unknown",
            normal: "Normal",
            likuma: {
                title: "Likuma",
                likumaTripInfo: "Likuma matkatapahtuma",
                likumaCharge: "Likuma maksutapahtuma",
                likumaCancel: "Likuma katevarauksen peruutus"
            },
            kela: {
                title: "Kela",
                kelaComboTrip: "Kela yhdistelymatka",
                kelaTripInfo: "Kela matkatapahtuma",
                kelaCharge: "Kela maksutapahtuma"
            },
            taxiPlus: {
                title: "TaxiPlus",
                taxiPlusTripInfo: "TaxiPlus matkatapahtuma",
                taxiPlusCharge: "TaxiPlus maksutapahtuma"
            },
            receipt: {
                title: "Kuitti",
                receiptTripInfo: "Matkan tiedot",
                receiptCharge: "Maksun tiedot",
                receiptComments: "Kommentit",
                cardTransactionInformation: "Korttitapahtuma",
                cardRehandleTitle: "Korttitapahtuman uudelleenkäsittely",
                verifoneEventDetailsTitle: "Verifone-tapahtuman tiedot",
                verifoneEventDuplicatesShow: "Näytä duplikaatit",
                verifoneEventCanBeHandled: "Tapahtuma voidaan käsitellä"
            },
            keusote: {
                title: "Keusote",
                keusoteTripInfo: "Keusote matkatapahtuma",
                keusoteCharge: "Keusote maksutapahtuma"
            },
            kaista: {
                title: "Kaista",
                kaistaTripInfo: "Kaista matkatapahtuma"
            },
            soteKaista: {
                title: "SoteKaista",
                tripInfo: "SoteKaista matkatapahtuma"
            },
            sote: {
                title: "Sote",
                soteComboTrip: "Sote yhdistelymatka",
                soteTripInfo: "Sote matkatapahtuma",
                soteCharge: "Sote maksutapahtuma"
            }
        },
        fields: {
            startTime: "Matkan aloitus",
            endTime: "Matkan lopetus",
            distance: "Matkan pituus",
            carNumber: "Autonumero",
            serviceNumber: "Palvelutunnus",
            driverId: "Kuljettajatunnus",
            serviceProviderVatId: "Palveluntuottaja Y-tunnus",
            orderId: "Tilaustunnus",
            routeNumber: "Reittitunnus",
            receiptNumber: "Kuittinumero",
            taximeterSerialNumber: "Taksamittarin sarjanumero",
            cardNumber: "Korttinumero",
            baseCost: "Perusmaksu",
            paymentType: "Maksun tyyppi",
            paymentMethod: "Maksuväline",
            costCenter: "Kustannuspaikka",
            vatPercent: "Alv%",
            cost: "Hinta",
            deductible: "Omavastuu",
            reimbursement: "Korvaus",
            discount: "Alennus",
            routeTotal: "Reitin hinta",
            comments: "Kommentit",
            salesInvoiceMessage: "Lisätietoa myyntilaskulle",
            purchaseInvoiceMessage: "Lisätietoa tilitykseen"
        },
        changeSearchCriteria: "Muuta hakuehtoja",
        searchForFailed: "Etsi virheellisiä",
        toggleColumns: "Valitse näytettävät arvot",
        toggleColumnsTitle: "Valitse näytettävät arvot",
        hideAllColumns: "Piilota kaikki",
        showAllColumns: "Näytä kaikki",
        resetDefaults: "Palauta oletukset",
        dragColumnsHint: "Voit muuttaa kenttien järjestystä vetämällä hiirellä",
        sentToExternalValidation: "Lähetetty tarkistettavaksi",
        validationFailReason: "Validaatio epäonnistui: {failReason}",
        salesInvoiceNumber: "Myyntilaskunumero: {invoiceNumber}",
        salesInvoiceKelaPaymentDate: "Kelan maksupvm",
        salesInvoiceSent: "Myyntilasku lähetetty",
        purchaseInvoiceNumber: "Ostolaskunumero: {invoiceNumber}",
        purchaseInvoiceSent: "Ostolasku lähetetty",
        preBookingExtra: "Etukäteen varattu",
        goodsExtra: "Tavaralisä",
        airportExtra: "Lentokenttälisä",
        serviceExtra: "Palvelulisä",
        aidExtra: "Avustuslisä",
        handicapExtra: "Invalisä",
        stretcherExtra: "Paarilisä",
        approachExtra: "Luokseajolisä",
        otherExtra: "Muu lisä",
        downloadCSV: "Lataa haetut tapahtumat CSV",
        correctTransportEvent: "OIKAISE MATKATAPAHTUMAA",
        createTransportEvent: "Luo matkatapahtuma",
        editTransportEvent: "Muokkaa matkatapahtumaa",
        editModelLabel: "Malli",
        editModelHint: "Näet vain ne kentät, jotka ovat relevantteja valitulle mallille",
        transportEventCannotBeModified: "Matkatapahtumaa ei voida muokata sen nykyisessä tilassa.",
        undoRemove: "Palauta tapahtuma muokattavaksi",
        sendCorrectedEvent: "Lähetä korjattu tapahtuma",
        updateComments: "Päivitä kommentit",
        addEvent: "Lisää tapahtuma",
        deleteEvent: "Poista tapahtuma",
        setNotToBeInvoiced: "Älä tilitä",
        setNotToBeInvoicedConfirm: "Haluatko varmasti asettaa tämän tapahtuman tilaan 'Älä tilitä'? Tätä toimenpidettä ei voi peruuttaa.",
        setInvoiceStates: "Aseta laskutustilat",
        setToBePurchaseInvoiced: "Vie tilitettäväksi",
        eventHasBeenCorrected: "Tämä tapahtuma on jo korjattu eikä sitä voi korjata uudelleen.",
        makeCorrections: "Tee korjauksia",
        makeCorrectionsInfo: "Korjauksen voi tehdä vain kerran. Korjattua tapahtumaa ei voi enää muokata.",
        eventInfo: "Muut tiedot",
        fares: "Taksat",
        extraCharges: "Lisät",
        waitFees: "Odotusmaksut",
        addNewFee: "Lisää uusi lisä",
        editFee: "Muokkaa lisää",
        feeType: "Lisän tyyppi",
        feeName: "Lisän nimi",
        addNewFare: "Lisää uusi taksa",
        editFare: "Muokkaa taksaa",
        fareType: "Taksatyyppi",
        fareClass: "Taksaluokka",
        kilometerPrice: "Kilometrihinta",
        kilometers: "Kilometrit",
        meters: "Metrit",
        time: "Aika",
        price: "Hinta",
        vat: "Alv",
        addFee: "Lisää lisä",
        addFare: "Lisää taksa",
        addNewWaitFee: "Lisää uusi odotusmaksu",
        waitFeeType: "Odotuslaji",
        hourPrice: "Tuntihinta",
        addWaitFee: "Lisää odotusmaksu",
        ditWaitFee: "Muokkaa odotusmaksua",
        validationStatusLabel: "Validoinnin tila",
        searchRange: "Etsi useita",
        searchSingle: "Etsi tunnisteella",
        totalReimbursementSum: "Yhteensä",
        paymentMethod: {
            title: "Maksutapa",
            unknown: "Tuntematon",
            notReceived: "Ei maksutapaa",
            cash: "Käteinen",
            debitCard: "Pankkikortti (debit)",
            creditCard: "Luottokortti (credit)",
            creditDebitCard: "Maksukortti (Credit/Debit)",
            debitCreditCard: "Maksukortti (Debit/Credit)",
            invoice: "Lasku",
            taxiCard: "Taksikortti",
            socialServiceCard: "Sosiaalipalvelukortti",
            app: "Applikaatio",
            externalPaymentService: "Ulkoinen maksupalvelu"
        },
        area: "Alue",
        createInvoices: "Luo laskut",
        searchEvents: "Etsi tapahtumat",
        sales: {
            title: "Myyntilaskut",
            creationTitle: "Myyntilaskulle valmiit tapahtumat",
            createdInvoices: "Luodut myyntilaskut",
            invoiceEventTypes: "Myyntilaskun tyyppi",
            invoicingStarted: "Myyntilaskujen luonti aloitettu",
            totalSum: "Yhteensä",
            lastInvoiceCreated: "Viimeisin myyntilasku luotu",
            noInvoiceCreated: "Ei luotuja myyntilaskuja",
            sendToSales: "Luo myyntilaskut",
            sendAllToSales: "Luo myyntilaskut kaikista",
            sendSelectedToSales: "Luo myyntilaskut valituista",
            summary: {
                title: "Myyntilaskujen yhteenveto",
                reimbursementSum: "Myyntilaskujen summa yhteensä",
                transportEventCount: "Myyntilaskuille menevien tapahtumien määrä",
                invoiceCount: "Myyntilaskujen määrä yhteensä"
            }
        },
        purchasing: {
            title: "Ostolaskut",
            creationTitle: "Ostolaskulle valmiit tapahtumat",
            createdInvoices: "Luodut ostolaskut",
            invoiceEventTypes: "Ostolaskun tyyppi",
            invoicingStarted: "Ostolausujen luonti aloitettu",
            totalSum: "Yhteensä",
            sendToPurchasing: "Luo ostolasku",
            lastInvoiceCreated: "Viimeisin ostolasku luotu",
            noInvoiceCreated: "Ei luotuja ostolaskuja",
            summary: {
                title: "Tilitettävien tapahtumien yhteenveto",
                reimbursementSum: "Tulevat tilitykset yhteensä",
                transportEventCount: "Tilitettävien tapahtumien määrä",
                invoiceCount: "Ostolaskujen määrä yhteensä",
                updated: "Päivitetty"
            }
        },
        batches: {
            title: "Invoicing batches",
            salesTitle: "Myyntilaskutusajot",
            purchaseTitle: "Ostolaskutusajot",
            cancelBatchInvoices: "Peruuta muodostetut laskut",
            showLogMessages: "Näytä lokiviestit",
            created: "Luotu",
            status: "Tila",
            invoicesExpected: "Oletus (kpl)",
            invoicesCreated: "Luodut (kpl)",
            invoicesVerified: "Maksetut (kpl)",
            totalSumEvents: "Tapahtumien summa",
            totalSumCreated: "Laskujen summa",
            totalSumVerified: "Maksettu summa",
            actions: "Toiminnot",
            verify: "Tarkista maksut",
            verifyStarted: "Tarkistus aloitettu"
        },
        filters: {
            title: "Laskutusasetukset",
            invoicingOptionsName: "Laskutusasetuksen nimi",
            transportEventFilterName: "Tapahtumasuodatimen nimi",
            transportEventsCount: "Tapahtumien määrä",
            customerCount: "Laskutettavien määrä",
            serviceProviderCount: "Tilitettävien määrä",
            totalReimbursementSum: "Summa yhteensä",
            oldestTripStart: "Vanhin matka",
            newestTripStart: "Uusin matka",
            actions: "Toiminnot",
            created: "Laskutusasetukset luotu onnistuneesti",
            updated: "Laskutusaasetukset päivitetty onnistuneesti",
            deleted: "Laskutusasetukset poistettu onnistuneesti",
            createSchedule: "Luo ajastus",
            scheduleTitle: "Luo ajastus suodattimelle",
            scheduleName: "Nimi",
            scheduleDescription: "Kuvaus",
            scheduleManualCron: "Syötä cron käsin",
            scheduleCronExpression: "Cron-lauseke",
            scheduleCreated: "Ajastus luotu onnistuneesti"
        },
        paytrail: {
            title: "Paytrail",
            transactions: "Paytrail-tapahtumat",
            settlementReport: "Paytrail-tilitysraportti",
            settlementId: "Tilitysnumero",
            search: "Etsi tilaus",
            handle: "Käsittele tapahtuma",
            createEvents: "Luo tapahtumat",
            eventCount: "Tapahtumien lukumäärä",
            sum: "Kokonaissumma",
            createEventsActionButton: "Luo tapahtumat",
            settle: "Merkkaa tilitettäväksi"
        },
        verifone: {
            title: "Verifone",
            missing: {
                title: "Puuttuvat Verifone-tapahtumat",
                handlingStatus: "Käsittelytila",
                createEvents: "Luo tapahtumat valituista",
                eventCount: "Tapahtumien määrä",
                sum: "Kokonaissumma",
                createEventsActionButton: "Luo tapahtumat"
            }
        },
        setInvoiceStatesDialog: {
            title: "Muuta laskutustiloja",
            salesInvoiceState: "Myyntilaskun tila",
            purchaseInvoiceState: "Ostolaskun tila",
            warningMessage: "HUOM: Laskutustilojen muuttaminen voi vaikuttaa laskutusprosessiin. Muuta tiloja vain, jos tiedät mitä teet."
        },
        transportEventSalesInvoiceStates: {
            unknown: "Määrittämätön",
            unprocessed: "Käsittelemätön",
            notToBeInvoiced: "Ei laskuteta",
            accepted: "Hyväksytty laskutukseen",
            denied: "Laskutus hylätty",
            waiting: "Odottaa laskutusta",
            completed: "Laskutus valmis",
            corrected: "Korjattu",
            readyForSalesInvoice: "Valmis myyntilaskutukseen"
        },
        transportEventPurchaseInvoiceStates: {
            unknown: "Määrittämätön",
            unprocessed: "Käsittelemätön",
            notToBeInvoiced: "Ei laskuteta",
            accepted: "Hyväksytty laskutukseen",
            denied: "Laskutus hylätty",
            waiting: "Odottaa laskutusta",
            completed: "Laskutus valmis"
        }
    },
    transportEventTable: {
        headers: {
            eventType: "Tapahtuman tyyppi",
            orderId: "Tilaustunnus",
            routeNumber: "Reittitunnus",
            validationStatus: "Validoinnin tila",
            salesInvoiceStatus: "Myyntilaskutuksen tila",
            purchaseInvoiceStatus: "Tilityksen tila",
            modified: "Muokattu",
            modifier: "Muokkaaja",
            customerName: "Asiakkaan nimi",
            costCenter: "Kustannuspaikka",
            startTime: "Matka alkoi",
            endTime: "Matka loppui",
            startingPoint: "Lähtöosoite",
            destination: "Määränpää",
            distance: "Matkan pituus (km)",
            duration: "Matkan kesto",
            slowDrive: "Hidasajo",
            waitingTime: "Odotusaika",
            tripType: "Matkatyyppi",
            carNumber: "Autonumero",
            serviceNumber: "Palvelutunnus",
            driverId: "Kuljettajatunnus",
            shiftNumber: "Vuoronumero",
            taximeterSerialNumber: "Mittarin sarjanumero",
            receiptNumber: "Kuittinumero",
            paymentMethod: "Maksutapa",
            paymentType: "Maksun tyyppi",
            cardNumber: "Korttinumero",
            comments: "Kommentit",
            vatPercent: "ALV-%",
            cost: "Kustannus",
            deductible: "Omavastuu",
            deductibleVat: "Omavastuu ALV",
            reimbursement: "Korvaus",
            reimbursementVat: "Korvaus ALV",
            discountAmount: "Alennuksen määrä",
            extras: "Lisät",
            waitingCost: "Odotusmaksu",
            waitingVat: "Odotusmaksu ALV",
            kela: {
                batchNumber: "Erätunnus",
                latestSettlementStatus: "Kela-tila"
            },
            likuma: {
                welfareTripType: "VPL/SHL",
                highTariff: "High tariff",
                certificateId: "Likuman certifikaatti"
            }
        }
    },
    invoicingRules: {
        title: "Laskutussäännöt"
    },
    keyValueInput: {
        key: "Avain",
        value: "Arvo"
    },
    validationError: {
        sumTooLarge: "Summa liian suuri"
    },
    vehicles: {
        title: "Ajoneuvot",
        dialogs: {
            integrationSources: "Välitysjärjestelmät",
            vehicleId: "Auton tunniste",
            vehicleNumber: "Auton numero",
            registrationPlateNumber: "Rekisterinumero",
            status: "Tila",
            twinType: "Twin-tyyppi",
            contactInformation: "Yhteystiedot",
            phoneNumber: "Puhelinnumero",
            email: "Sähköposti"
        }
    },
    charts: {
        valid: "Kunnossa",
        incomplete: "Maksu- tai tilaustapahtuma puuttuu",
        orderMissing: "Tilaus puuttuu",
        receiptMissing: "Kuitti puuttuu",
        validationFailed: "Virheellinen",
        waitingForInvoicing: "Odottaa laskutusta",
        salesInvoiceSent: "Myyntilasku tehty",
        purchaseInvoiceSent: "Ostolasku tehty",
        readyForExternalValidationKela: "Valmis lähettäväksi Kelaan",
        waitingForExternalValidationKela: "Odottaa Kelan hyväksyntää",
        totalCharge: "Kokonaissumma",
        aggregated: "Aggregoitu",
        detailed: "Yksityiskohtainen"
    },
    processes: {
        title: "Prosessit",
        subtitle: "Kaikkien workereiden viimeisimmät ajot kaikilta tenanteilta",
        refresh: "Päivitä",
        filterAll: "Kaikki",
        filterRunning: "Käynnissä",
        filterCompleted: "Valmis",
        filterFailed: "Virhe",
        colTenant: "Tenant",
        colTitle: "Prosessi",
        colTriggerType: "Tyyppi",
        colStatus: "Status",
        colStartedAt: "Aloitettu",
        colDuration: "Kesto",
        colError: "Virhe",
        noMetadata: "Ei metatietoja"
    }
};

export default fi;
